<template>
  <view-container>
    <list-header
      :add="
        !auth.user.isPartner &&
          (!auth.user.isAdmin || filter.clientId) && {
            name: 'order-new',
            params: { clientId: filter.clientId, cashierId: filter.cashierId }
          }
      "
    >
      <v-col cols="12" :md="showClientFilter ? 3 : 5">
        <search-field
          v-model="filter.search"
          :disabled="isPartnerWithNoFilter"
          placeholder="Номер заказа (идентификатора)"
        />
      </v-col>
      <v-col cols="12" md="3" v-if="showClientFilter">
        <reference-field
          label="Клиент"
          reference="client"
          v-model="filter.clientId"
        />
      </v-col>
      <v-col cols="12" :md="showClientFilter ? 3 : 5" v-if="!scope">
        <reference-field
          :disabled="auth.user.isPartner && !filter.clientId"
          label="Кассир"
          reference="cashier"
          v-model="filter.cashierId"
          :filter="cashierFilter"
        />
      </v-col>
      <v-col cols="12" :md="showClientFilter ? 3 : 2" align-self="center">
        <v-container class="d-flex justify-end px-0">
          <v-menu
            v-if="!isPartnerWithNoFilter"
            v-model="filterMenu"
            offset-y
            :close-on-content-click="false"
            left
            nudge-bottom="10"
          >
            <template v-slot:activator="{ on }">
              <v-btn outlined small v-on="on" class="btn--bordered-grey">
                <v-icon small>mdi-filter-outline</v-icon>&nbsp;Фильтры
              </v-btn>
            </template>
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6" style="min-width: 290px">
                    <div class="font-weight-bold">Способы оплаты</div>
                    <v-checkbox
                      v-model="allPaymentMethods"
                      label="Все"
                      hide-details
                    ></v-checkbox>
                    <v-divider class="my-4"></v-divider>
                    <v-checkbox
                      v-for="type in paymentTypes"
                      :key="type.id"
                      v-model="checkedPaymentMethods"
                      :value="type.id"
                      :label="type.name"
                      hide-details
                    >
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="font-weight-bold" style="min-width: 290px">
                      Фискальные данные
                    </div>
                    <v-text-field
                      v-model.number="filterMenuValues.shiftNumber"
                      label="Номер смены"
                      type="number"
                    />
                    <v-text-field
                      v-model.number="filterMenuValues.receiptNumber"
                      dense
                      label="Номер чека"
                      type="number"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                  text
                  small
                  color="rgba(0, 0, 0, 0.54)"
                  @click="filterMenu = false"
                  class="font-weight-bold"
                  >Закрыть</v-btn
                >
                <v-spacer />
                <v-btn
                  text
                  small
                  color="rgba(0, 0, 0, 0.54)"
                  @click="discardMenuFilter"
                  class="font-weight-bold"
                  >Сбросить</v-btn
                >
                <v-btn
                  text
                  small
                  color="rgba(0, 0, 0, 0.54)"
                  @click="applyMenuFilter"
                  class="font-weight-bold"
                  >Применить</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-container>
      </v-col>
      <v-col cols="12">
        <date-range-filter
          v-if="!isPartnerWithNoFilter"
          v-model="dateRange"
          :presets="datePresets"
          max="now"
        />
      </v-col>
    </list-header>
    <v-card v-if="!isPartnerWithNoFilter">
      <OrderListComp :items="filteredItems" />
      <data-loader :watch="filter" :load="load" v-model="items" />
    </v-card>
    <p v-if="stats && stats.totalCount > 0" class="pa-4 opacity-1">
      Всего {{ stats.totalCount }} на сумму {{ stats.amount | currency }}
    </p>
  </view-container>
</template>
<script>
import ds from "@/datastore";
import OrderListComp from "@/components/ui/OrderList";
import moment from "moment";
import { auth } from "@/mixins";
import { PaymentTypes } from "@/datastore/enums";
export default {
  name: "OrderList",
  mixins: [auth],
  components: { OrderListComp },
  props: {
    id: String
  },
  data() {
    return {
      items: [],
      filter: {
        clientId: undefined,
        cashierId: undefined,
        createdFrom: undefined,
        createdTo: undefined,
        search: "",
        paymentMethods: []
      },
      scope: null,
      now: new Date(),
      loaded: false,
      filterMenu: false,
      filterMenuValues: {},
      paymentTypes: PaymentTypes,
      allPaymentMethods: false,
      checkedPaymentMethods: []
    };
  },
  activated() {
    this.scope = this.$route.meta.scope;
    if (this.scope == "cashier") {
      this.auth.user.isPartner &&
        (this.filter.clientId = this.$store.state.clientId);
      this.filter.cashierId = this.id;
    }
  },
  computed: {
    showClientFilter() {
      return !this.scope && !this.auth.user.clientId;
    },
    filteredItems() {
      return this.filter.cashierId
        ? this.items.filter(item => item.cashierId == this.filter.cashierId)
        : this.items;
    },
    isPartnerWithNoFilter() {
      return (
        this.auth.user.isPartner &&
        !this.filter.clientId &&
        !this.filter.cashierId
      );
    },
    stats() {
      return (
        this.loaded &&
        this.filteredItems.reduce(
          (acc, val) => {
            acc.totalCount++;
            acc.amount += val.paymentAmountSigned;
            return acc;
          },
          { totalCount: 0, amount: 0 }
        )
      );
    },
    cashierFilter() {
      return { clientId: this.filter.clientId };
    },
    dateRange: {
      set(v) {
        if (v.length == 2) {
          this.filter.createdFrom = moment(v[0]).format();
          this.filter.createdTo = moment(v[1]).format();
        } else if (v.length == 1) {
          this.filter.createdFrom = moment(v[0])
            .startOf("day")
            .format();
          this.filter.createdTo = moment(v[0])
            .endOf("day")
            .format();
        } else {
          this.filter.createdFrom = undefined;
          this.filter.createdTo = undefined;
        }
      },
      get() {
        return [];
      }
    },
    datePresets() {
      return [
        { title: "Все", range: () => [] },
        {
          title: "Сегодня",
          range: () => [moment(this.now).format()],
          default: true
        },
        {
          title: "Вчера",
          range: () => [
            moment(this.now)
              .subtract(1, "days")
              .format()
          ]
        }
      ];
    },
    rels() {
      let rels = ["cashier", "group", "group.company"];
      if (!this.auth.user.clientId) {
        rels.push("group.company.client");
      }
      return rels;
    }
  },
  watch: {
    "filter.clientId": function(newVal, oldVal) {
      oldVal && (this.filter.cashierId = undefined);
    },
    checkedPaymentMethods: function(newVal) {
      this.allPaymentMethods = newVal.length == this.paymentTypes.length;
    },
    allPaymentMethods: function(newVal) {
      if (newVal) {
        this.paymentTypes.forEach(type =>
          this.checkedPaymentMethods.indexOf(type.id) == -1
            ? this.checkedPaymentMethods.push(type.id)
            : ""
        );
      }
    },
    filterMenu: function(newVal) {
      if (!newVal) {
        this.checkedPaymentMethods = this.filter.paymentMethods.slice();
        this.filterMenuValues = {
          shiftNumber: this.filter.shiftNumber,
          receiptNumber: this.filter.receiptNumber
        };
      }
    }
  },
  methods: {
    async load(pager) {
      this.loaded = false;
      var f = { ...this.filter };
      if (f.paymentMethods.length == this.paymentTypes.length) {
        f.paymentMethods = [];
      }
      let items = await ds.findAll("order", {
        ...pager,
        ...f
      });
      if (items.length < pager.limit || items.length == 0) {
        this.loaded = true;
      }
      items.forEach(item => item.loadRelations(this.rels));
      return items;
    },
    applyMenuFilter() {
      this.filter.paymentMethods = this.checkedPaymentMethods.slice();
      this.filter.shiftNumber = this.filterMenuValues.shiftNumber || undefined;
      this.filter.receiptNumber =
        this.filterMenuValues.receiptNumber || undefined;
      this.filterMenu = false;
    },
    discardMenuFilter() {
      this.allPaymentMethods = true;
      this.filterMenuValues = {};
    }
  },
  created() {
    setInterval(() => (this.now = new Date()), 5000);
    ds.on("afterCreate", (mapperName, props, opts, result) => {
      mapperName === "order" && this.items.unshift(result);
    });
    ds.on("afterRegistration", (mapperName, item) => {
      mapperName === "order" &&
        !this.items.includes(item) &&
        this.items.unshift(item) &&
        item.loadRelations(this.rels);
    });
  },
  mounted() {
    this.allPaymentMethods = true;
    this.paymentTypes.forEach(type => this.filter.paymentMethods.push(type.id));
  }
};
</script>

<style lang="stylus" scoped>
.v-input--checkbox
  margin-top 5px
  margin-bottom 5px
  >>> .v-label
    font-size 14px
.btn--bordered-grey
  border-color rgba(0, 0, 0, 0.12)
</style>
